/* eslint-disable */

import {
  computeMaxValueFromValues,
  computeNewValuesOnUpdate,
  getColorHex,
} from "../../logic/logic";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";
import RaindropMotionFadeUp from "../raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import PercentageDisplay from "../percentage-display/percentage-display.tsx";
import RaindropSlider from "../raindrop-slider/raindrop-slider.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import { SausageStyleColor, Size } from "../../logic/enums.ts";
import FlexRow from "../flex-row/flex-row.tsx";
import { useEffect, useState } from "react";
import { isLocalEnvironment } from "../../services/environment.js";
import JSONBlob from "../json-blob/json-blob.tsx";
import RaindropMotionFadeDown from "../raindrop-motion-fade-down/raindrop-motion-fade-down.tsx";

const SaveCancelPanel = ({
  hasChanged = false,
  sausageValues,
  setValues = (x) => {},
  setIsShowingColorSelector = (x) => {},
}) => {
  const onSave = () => {
    if (!hasChanged) {
      return;
    }

    const newValues = sausageValues.map((sausage) => {
      return {
        ...sausage,
        oldValue: sausage.value,
        oldColor: sausage.color,
      };
    });
    setValues(newValues);
    setIsShowingColorSelector(false);
  };

  const onCancel = () => {
    const newValues = sausageValues.map((value) => {
      return {
        ...value,
        value: value.oldValue,
        color: value?.oldColor,
      };
    });
    setValues(newValues);
    setIsShowingColorSelector(false);
  };

  if (!hasChanged) {
    return null;
  }

  return (
    <RaindropMotionFadeDown>
      <FlexRow>
        <RaindropButton
          style={ButtonStyle.Tertiary}
          size={Size.Large}
          title="Cancel"
          onClick={onCancel}
          isFluid={true}
        />
        <RaindropButton
          isFluid={true}
          size={Size.Large}
          style={ButtonStyle.Primary}
          title={"Save"}
          onClick={onSave}
        />
      </FlexRow>
    </RaindropMotionFadeDown>
  );
};

const ColorSelections = ({ isShowingColorSelector, setNewColor }) => {
  if (!isShowingColorSelector) {
    return null;
  }

  return (
    <RaindropMotionFadeUp>
      <FlexRow className="overflow-x-scroll no-scrollbar">
        <ColorSelectorBox
          color={SausageStyleColor.Pink}
          onClick={() => {
            setNewColor(SausageStyleColor.Pink);
          }}
        />
        <ColorSelectorBox
          color={SausageStyleColor.Blue}
          onClick={() => {
            setNewColor(SausageStyleColor.Blue);
          }}
        />
        <ColorSelectorBox
          color={SausageStyleColor.Yellow}
          onClick={() => {
            setNewColor(SausageStyleColor.Yellow);
          }}
        />
        <ColorSelectorBox
          color={SausageStyleColor.Green}
          onClick={() => {
            setNewColor(SausageStyleColor.Green);
          }}
        />
        <ColorSelectorBox
          color={SausageStyleColor.Purple}
          onClick={() => {
            setNewColor(SausageStyleColor.Purple);
          }}
        />

        <ColorSelectorBox isLocked={true} />
        <ColorSelectorBox isLocked={true} />
      </FlexRow>
    </RaindropMotionFadeUp>
  );
};

const ColorSelectorBox = ({
  color = SausageStyleColor.Pink,
  isLocked = false,
  onClick = () => {},
}) => {
  let maybeTailwindBackground = "";

  if (isLocked) {
    maybeTailwindBackground =
      "bg-color-background-primary dark:bg-color-dark-background-primary";
  }

  return (
    <RaindropClickable onClick={onClick}>
      <div
        className={`flex flex-row gap-2 border-2   h-12 w-12 min-w-14 aspect-square rounded-xl border-color-border-secondary dark:border-color-dark-border-tertiary  items-center justify-center bg-color-border-secondary dark:bg-color-dark-border-secondary ${maybeTailwindBackground} `}
        style={{
          opacity: isLocked ? 0.4 : 1,
          backgroundColor: isLocked ? null : getColorHex(color),
        }}
      >
        {isLocked && (
          <i className="fa fa-lock text-black dark:text-white opacity-20" />
        )}
        {!isLocked && (
          <div className="w-5 h-2 bg-white rounded-xl opacity-40 translate-x-1 translate-y-3" />
        )}
      </div>
    </RaindropClickable>
  );
};

const ContributionSlider = ({
  sausageValue,
  sausageValues,
  setValues = (x) => {},
  doShowSaveBar = true,
}) => {
  const [isShowingColorSelector, setIsShowingColorSelector] = useState(false);
  const [newColor, setNewColor] = useState(
    sausageValue?.color ? sausageValue.color : SausageStyleColor.Pink
  );

  const hasChanged = sausageValues?.some(
    (v) => v?.oldValue !== v.value || v.oldColor !== v.color
  );

  useEffect(() => {
    const newValues = [...sausageValues];

    const index = newValues.findIndex(
      (v) =>
        (v.waterfall && v.waterfall?.id === sausageValue?.waterfall?.id) ||
        (v.organisation &&
          v.organisation?.id === sausageValue?.organisation?.id)
    );

    if (index === -1) {
      return;
    }

    newValues[index].color = newColor;

    setValues(newValues);
  }, [newColor]);

  if (!sausageValue) {
    return null;
  }

  if (sausageValues.length === 1) {
    return null;
  }

  let maxValue = computeMaxValueFromValues(sausageValues, sausageValue);

  const onChange = (newValue) => {
    const newValues = [...sausageValues];

    const index = newValues.findIndex(
      (v) =>
        (v.waterfall && v.waterfall?.id === sausageValue.waterfall?.id) ||
        (v.organisation && v.organisation?.id === sausageValue.organisation?.id)
    );

    if (index === -1) {
      return;
    }

    const newValuesResult = computeNewValuesOnUpdate(
      newValue,
      index,
      sausageValues.map((value) => value.value),
      sausageValues.map((value) => value.locked),
      10
    );

    newValues.forEach((value, i) => {
      value.value = newValuesResult[i];
    });

    setValues(newValues);
  };

  return (
    <RaindropMotionFadeUp key={sausageValue.id}>
      <div className="flex flex-col w-full gap-4">
        <ColorSelections
          isShowingColorSelector={isShowingColorSelector}
          setNewColor={setNewColor}
        />

        <FlexRow>
          <RaindropCard additionalClasses="rounded-full px-6 py-0">
            <div className="flex flex-row w-full items-center gap-4 ">
              <PercentageDisplay value={10} />
              <RaindropSlider
                value={sausageValue.value}
                onChange={onChange}
                max={maxValue}
                color={sausageValue.color}
              />
              <PercentageDisplay value={100} max={100} />
            </div>
          </RaindropCard>
          <ColorSelectorBox
            color={sausageValue.color}
            onClick={() => {
              setIsShowingColorSelector((prev) => !prev);
            }}
          />
        </FlexRow>

        {doShowSaveBar && (
          <SaveCancelPanel
            hasChanged={hasChanged}
            setValues={setValues}
            sausageValues={sausageValues}
            setIsShowingColorSelector={setIsShowingColorSelector}
          />
        )}
      </div>
    </RaindropMotionFadeUp>
  );
};

export default ContributionSlider;
